import Timer from 'components/Timer';
import Timer2 from 'components/Timer2';
import Layout from 'containers/Layout';
import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import { width, sizes, helpers, colors, media } from 'styles/variables';
import Meta from 'utils/Meta';
import RichText from 'utils/RichText';
import { log, fblog, eclog, slog } from 'utils/log';
import { navigate } from 'gatsby';
import { loadStripe } from '@stripe/stripe-js';
import GO from 'utils/GO';
import radio_0 from '../../static/radio_0.svg';
import radio_1 from '../../static/radio_1.svg';
import { PayPalButton } from 'react-paypal-button-v2';
import animateScrollTo from 'animated-scroll-to';
import VisibilitySensor from 'react-visibility-sensor';
import Button from 'components/Button';
import 'url-search-params-polyfill';
import firebase from 'gatsby-plugin-firebase';
import checkbox_0 from '../../static/checkbox_0.svg';
import checkbox_1 from '../../static/checkbox_1.svg';
import Script from 'react-load-script';
import axios from 'axios';

const Summary = styled.div`
	margin: 30px 0 0;
	width: 100%;
	border: 1px solid rgba(0, 0, 0, 0.1);
	border-radius: ${sizes[0]};
	padding: ${sizes[2]};
	.headline {
		font-size: 1.25rem;
		font-weight: bold;
		text-align: left;
		display: block;
	}
	.order,
	.total {
		display: grid;
		grid-template-columns: 1fr auto;
		grid-gap: ${sizes[1]};
		align-items: end;
		line-height: 1.25rem;
		.key {
			text-transform: capitalize;
			text-align: left;
			// font-weight: bold;
			strong {
				display: block;
				font-weight: 600;
				font-size: 0.9rem;
			}
		}
		.value {
			text-align: right;
			// font-weight: regular;
		}
	}
	.order {
		margin: ${sizes[2]} 0;
		padding: ${sizes[2]} 0;
		border-top: 1px solid rgba(0, 0, 0, 0.1);
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		font-size: 0.9rem;
	}
	.total {
		font-weight: bold;
		font-size: 1.1rem;
		margin-bottom: ${sizes[2]};
		padding-bottom: ${sizes[2]};
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	}
`;
const PageWrapper = styled.div`
	.paddle-checkout {
		min-height: 200px;
		margin: 0 -0.65rem;
		position: relative;
		overflow: hidden;
		&.--loading:before {
			content: '';
			display: block;
			position: absolute;
			width: 200%;
			height: 200%;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			z-index: 99;
			pointer-events: none;
			background: white;
			z-index: 999;
		}
		.loader {
			display: none;
		}
		&.--loading .loader {
			display: inline-block;
			position: absolute;
			top: 50%;
			left: 50%;
			width: 34px;
			height: 34px;
			margin-top: -17px;
			margin-left: -17px;
			border: 4px solid #f3f3f3;
			border-radius: 50%;
			border-top: 4px solid #ccc;
			animation: rotate 1s ease-in-out infinite forwards;
			z-index: 9999;
		}
		@keyframes rotate {
			from {
				transform: rotate(45deg);
			}
			to {
				transform: rotate(405deg);
			}
		}
	}
	.checkOutButton {
		width: 100%;
		background: ${colors.teal.base};
		margin: 5px 0;
		padding: 16px;
		color: #fff;
		font-size: 14px;
		font-weight: 500;
		border-radius: 4px;
		cursor: pointer;
		&:hover {
			filter: brightness(0.9);
		}
	}
	.checkOutBottom {
		img {
			width: 100%;
			max-width: 400px;
			margin: 0 0 15px;
		}
	}
	margin: 0 auto;
	width: 100%;
	max-width: ${width.small}px;
	text-align: center;
	overflow: hidden;
	h1 {
		font-size: 3rem;
	}
	${media.notsmall} {
		padding: ${sizes[4]} ${sizes[2]};
		img {
			width: 90%;
		}
	}
	${media.small} {
		h1 {
			padding: ${sizes[2]};
			font-size: 2rem;
		}
		padding: ${sizes[3]} 0 0;
		img {
			width: 110%;
			margin-left: -5%;
		}
	}
`;
const PaymentBlock = styled.div`
	position: relative;
	.legalBlocker {
		display: block;
		position: absolute;
		top: -10px;
		right: -10px;
		bottom: -10px;
		left: -10px;
		z-index: 9999;
	}
`;
const Bot = styled.div`
	label {
		display: grid;
		grid-template-columns: auto 1fr;
		grid-gap: ${sizes[1]};
		> div:first-of-type:before {
			content: '';
			display: block;
			width: 20px;
			height: 20px;
			background: center no-repeat;
			background-size: contain;
		}
		> div:first-of-type:before {
			background-image: url(${checkbox_0});
		}
		&.--active > div:first-of-type:before {
			background-image: url(${checkbox_1});
		}
		&.--alert {
			* {
				color: red;
				font-weight: bold;
			}
		}
	}
	input {
		display: none;
	}
	width: 100%;
	margin: ${sizes[3]} auto ${sizes[2]};
	text-align: left;
	* {
		color: ${colors.foreground[2]};
		font-size: 0.8rem;
		line-height: 1.25rem;
	}
	a {
		text-decoration: underline;
		&:hover {
			text-decoration: none;
		}
	}
`;

const Order2 = styled.div`
	display: grid;
	grid-auto-flow: row;
	grid-gap: ${sizes[2]};
	position: relative;
	max-width: 500px;
	margin: 0 auto;
	${media.notsmall} {
		padding: ${sizes[3]};
		border-radius: ${sizes[1]};
		margin-top: -${sizes[2]};
	}
	${media.small} {
		padding: ${sizes[2]};
		margin-top: -${sizes[1]};
	}
`;
const Plans2 = styled.div`
	display: grid;
	grid-auto-flow: columns;
	grid-auto-columns: auto;
	grid-gap: ${sizes[2]};
	${media.small} {
		grid-gap: ${sizes[1]};
	}
	label {
		position: relative;
		${helpers.shadow};
		padding: ${sizes[2]};
		border-radius: ${sizes[1]};
		background: ${colors.background[0]};
		border: 3px solid ${colors.background[0]};
		cursor: pointer;
		text-align: left;
		input[type='radio'] {
			display: none;
		}
		> div {
			display: grid;
			grid-template-columns: 30px 1fr;
		}
		.status:first-of-type:before {
			content: '';
			display: block;
			width: 20px;
			height: 20px;
			background: center no-repeat;
			background-size: contain;
			background-image: url(${radio_0});
		}
		&.--active .status:first-of-type:before {
			background-image: url(${radio_1});
		}
		&:first-of-type {
			border-top-width: 30px;
			&:before {
				content: 'MOST POPULAR CHOICE';
				position: absolute;
				top: -30px;
				left: 0;
				right: 0;
				height: 30px;
				text-align: center;
				display: grid;
				align-items: center;
				font-size: 0.7rem;
				font-weight: 600;
				color: ${colors.teal.base};
				border-bottom: 1px solid ${colors.background[1]};
			}
		}
		&:hover {
			border-color: ${colors.teal.tint2};
		}
		h2 {
			font-size: 0.7rem;
			text-transform: uppercase;
			display: block;
		}
		h3 {
			font-size: 1.5rem;
			line-height: 2rem;
			display: block;
			span {
				background: none;
				color: ${colors.foreground[0]};
				font-size: 1rem;
				font-weight: normal;
				text-transform: lowercase;
			}
		}
		small {
			font-size: 0.7rem;
			display: block;
			margin-top: -5px;
			span {
				color: ${colors.foreground[2]};
				&:first-of-type {
					color: ${colors.brand.base};
					text-decoration: line-through;
				}
			}
		}
		.discount {
			position: absolute;
			top: ${sizes[2]};
			right: ${sizes[2]};
			background: ${colors.background[2]};
			border-radius: ${sizes[0]};
			padding: ${sizes[1]};
			text-align: center;
			font-size: 0.7rem;
			font-weight: 600;
			text-transform: uppercase;
			color: ${colors.foreground[2]};
		}
		&.--active {
			border-color: ${colors.teal.base};
			background: ${colors.teal.tint2};
			&:before {
				color: ${colors.background[0]};
			}
			.discount {
				background: ${colors.teal.base};
				color: ${colors.background[0]};
			}
		}
	}
`;
const Reviews = styled.div`
	padding: ${sizes[3]} 0;
	background: rgba(0, 0, 0, 0.025);
	> div {
		display: block;
		> div {
			display: grid;
			${media.large} {
				grid-template-columns: repeat(2, 1fr);
			}
			grid-gap: ${sizes[2]};
			> div {
				background: ${colors.background[0]};
				border-radius: ${sizes[0]};
				padding: ${sizes[3]};
				${helpers.shadow};
			}
		}
	}
	h2 {
		font-size: 1.5rem;
		margin-bottom: ${sizes[3]};
		display: block;
		width: 100%;
		text-align: center;
	}
	a {
		${media.large} {
			grid-column: span 2;
		}
		> * {
			max-width: 380px;
			margin: 0 auto;
		}
	}
`;
const ReviewItem = styled.div`
	position: relative;
	display: grid;
	grid-template-rows: 1fr auto;
	grid-gap: ${sizes[3]};
`;
const ReviewBody = styled.div`
	${media.notlarge} {
		margin-top: 40px;
	}
`;
const ReviewFooter = styled.div`
	display: grid;
	grid-template-columns: auto 1fr auto;
	align-items: center;
	.avatar {
		width: 48px;
		margin-right: ${sizes[1]};
		border-radius: 99px;
	}
	strong,
	small {
		display: block;
	}
	.rating {
		height: 24px;
		${media.notlarge} {
			position: absolute;
			top: ${sizes[3]};
			left: ${sizes[3]};
		}
	}
`;

const Block = styled.div`
	padding: ${sizes[4]} ${sizes[2]};
	width: 100%;
	max-width: ${width.max}px;
	margin: 0 auto;
	display: grid;
	${media.notsmall} {
		grid-template-columns: 1fr 2fr;
	}
	${media.small} {
		grid-template-columns: 100%;
		padding-bottom: ${sizes[2]};
	}
	grid-gap: ${sizes[3]};
	h1 {
		font-size: 2.25rem;
	}
	p {
		font-size: 0.9rem;
	}
	a {
		display: block;
	}
	.cta {
		margin-top: ${sizes[2]};
	}
	&.plain,
	&.testimonials {
		grid-template-columns: 1fr;
		grid-auto-flow: row;
		text-align: center;
		.offer,
		.cta {
			display: none;
		}
	}
	&.plain {
		${media.notsmall} {
			padding: ${sizes[5]};
			h1 {
				font-size: 3rem;
			}
			a > div {
				max-width: 300px;
				margin: 0 auto;
			}
		}
		${media.small} {
			padding: ${sizes[4]} ${sizes[2]};
		}
		.cta {
			display: block;
		}
	}
`;
const Benefits2 = styled.div`
	background: rgba(0, 0, 0, 0.025);
	> div {
		padding: ${sizes[3]} ${sizes[2]};
		display: block;
		> div {
			display: grid;
			${media.large} {
				grid-template-columns: repeat(4, 1fr);
			}
			${media.notlarge} {
				grid-template-columns: repeat(2, 1fr);
			}
			grid-gap: ${sizes[1]};
			text-align: left;
			> div {
				display: grid;
				grid-template-columns: auto 1fr;
				align-items: center;
			}
			img {
				display: inline-block;
				${media.large} {
					width: 32px;
				}
				${media.notlarge} {
					width: 28px;
				}
			}
			p {
				display: inline-block;
				width: 100%;
				padding: 0 0 0 ${sizes[1]};
				white-space: nowrap;
				line-height: 100%;
				${media.large} {
					font-size: 1rem;
				}
				${media.notlarge} {
					font-size: 0.75rem;
				}
			}
		}
	}
	h2 {
		font-size: 1.5rem;
		margin-bottom: ${sizes[3]};
		display: block;
		width: 100%;
		text-align: center;
	}
	a {
		${media.large} {
			grid-column: span 4;
		}
		${media.notlarge} {
			grid-column: span 2;
		}
		> * {
			max-width: 380px;
			margin: 0 auto;
		}
	}
`;

export default props => {
	const [config] = useState(require(`data/config`));
	const [meta] = useState(require(`data/meta`));
	const [values, setValues] = useState(null);
	const [order, setOrder] = useState(require(`data/order`));
	const [legal, setLegal] = useState(false);
	const [legalAlert, setLegalAlert] = useState(false);
	const [locale, setLocale] = useState(null);

	const handleLegal = action => {
		switch (action) {
			case 'toggle':
				setLegal(!legal);
				setLegalAlert(false);
				break;
			case 'alert':
				console.log('alert');
				setLegalAlert(true);
				break;
		}
	};

	const id = typeof document !== 'undefined' ? new URLSearchParams(document.location.search).get('id') : '';
	useEffect(() => {
		if (id) {
			try {
				axios.get('https://geoip.boredpanda.com/').then(response => {
					let geoip = response.data;
					setLocale(response.data);
					firebase
						.auth()
						.signInWithEmailAndPassword(atob(id), '_reshape_no_password')
						.then(user => {
							window._uid = user.user.uid;
							firebase
								.firestore()
								.collection('users')
								.doc(window._uid)
								.get()
								.then(docRef => {
									let doc = docRef.data();
									if (typeof doc !== 'undefined') {
										setValues(doc);
										if (typeof doc.order === 'undefined') {
											setPlan(order.plans[0]);
											renderInlinePaddle(doc, geoip, order.plans[0]);
											firebase
												.firestore()
												.collection('users')
												.doc(window._uid)
												.update({
													order: order.plans[0],
												});
										} else {
											setPlan(doc.order);
											renderInlinePaddle(doc, geoip, doc.order);
										}
										let url = new URLSearchParams(document.location.search);
										if (url.has('cancel')) {
											window.history.replaceState(
												'',
												document.title,
												window.location.href.replace('cancel&', ''),
											);
											slog(`Cancel Checkout`, doc.json.email);
										}
									} else {
										navigate('/');
									}
								})
								.catch(err => {
									navigate('/');
								});
						})
						.catch(err => {
							navigate('/');
						});
				});
			} catch (error) {
				navigate('/');
			}
		} else {
			navigate('/');
		}
	}, []);

	const handleCallToAction = e => {
		window._exps.TogglePaddle !== 2 && animateScrollTo(document.querySelector('#summary'));
	};

	const handleOptionChange = e => {
		showLoader();
		window._exps.TogglePaddle !== 2 && animateScrollTo(document.querySelector('#summary'));
		fblog('track', 'CustomizeProduct');
		let newOrder = JSON.parse(JSON.stringify(order));
		let newPlan = {};
		newOrder.plans = newOrder.plans.map((item, index) => {
			if (item.name === e.target.value) {
				item.value = true;
				newPlan = item;
			} else {
				item.value = false;
			}
			return item;
		});
		setOrder(newOrder);
		renderInlinePaddle(null, null, newPlan);
		firebase
			.firestore()
			.collection('users')
			.doc(window._uid)
			.update({
				order: newPlan,
			})
			.then(function() {
				console.log('Document updated successfully');
			})
			.catch(function(error) {
				console.error('Error updating document: ', error);
			});
	};

	const getPlan = () => {
		let plan;
		plan = order.plans.filter((item, index) => {
			return item.value;
		});
		if (plan.length) {
			return plan[0];
		} else {
			return order.plans[0];
		}
	};

	const setPlan = plan => {
		let newOrder = JSON.parse(JSON.stringify(order));
		newOrder.plans = newOrder.plans.map((item, index) => {
			if (item.name === plan.name) {
				item.value = true;
			} else {
				item.value = false;
			}
			return item;
		});
		setOrder(newOrder);
	};

	const renderInlinePaddle = (d = null, geoip = null, orderPlan = null) => {
		if (document.querySelector('.paddle-checkout')) {
			const config = {
				country: geoip ? geoip.countrycode : locale ? locale.countrycode : null,
				postcode: geoip ? geoip.zipcode : locale ? locale.zipcode : null,
				email: d ? d.email : values ? values.email : null,
				product:
					process.env.NODE_ENV === 'production' &&
					!(typeof window !== 'undefined' && window.location.origin.indexOf('netlify') > -1)
						? orderPlan
							? orderPlan.paddle_id
							: getPlan().paddle_id
						: orderPlan
						? orderPlan.paddle_sb_id
						: getPlan().paddle_sb_id,
				success: `${window.location.origin}/create-profile?id=${id}&pad=0`,
			};
			axios
				.post('/.netlify/functions/paddle_paylink', {
					data: { ...config },
				})
				.then(data => {
					window.Paddle.Checkout.open({
						override: data.data.response.url,
						method: 'inline',
						frameTarget: 'paddle-checkout-wrapper',
						frameInitialHeight: 366,
						frameStyle: 'width:100%; background-color: transparent; border: none;',
					});
				});
		}
	};

	const handlePaddleOverlay = () => {
		const config = {
			country: locale ? locale.countrycode : null,
			postcode: locale ? locale.zipcode : null,
			email: values ? values.email : null,
			product:
				process.env.NODE_ENV === 'production' &&
				!(typeof window !== 'undefined' && window.location.origin.indexOf('netlify') > -1)
					? getPlan().paddle_id
					: getPlan().paddle_sb_id,
			success: `${window.location.origin}/create-profile?id=${id}&pad=0`,
		};
		axios
			.post('/.netlify/functions/paddle_paylink', {
				data: { ...config },
			})
			.then(data => {
				window.Paddle.Checkout.open({ override: data.data.response.url });
			});
	};

	const handlePaddleOverride = () => {
		console.log('handlePaddleOverride');
		window.Paddle.Checkout.open({
			method: 'overlay',
			override:
				'https://checkout.paddle.com/checkout/custom/eyJ0IjoiVGVzdCBQbGFuICgxMiBtb250aHMpIiwiaSI6Imh0dHBzOlwvXC9zdGF0aWMucGFkZGxlLmNvbVwvYXNzZXRzXC9pbWFnZXNcL2NoZWNrb3V0XC9kZWZhdWx0X3Byb2R1Y3RfaWNvbi5wbmciLCJyIjoiXC9hcHAiLCJjbSI6IiIsInJlIjoxLCJwIjo2MDA3MDIsImFsIjowLCJ5IjoiIiwicSI6MCwiZCI6MSwiYSI6W10sInYiOiIxMTY2NjciLCJkdyI6ZmFsc2UsInMiOiIxMDA0MzhkMWNmZmI4NmMyZDFjZGFlOGJiOGZlMmUyOGVlZmMwNzQyMWZiMzg4ZDQwMTUwNzNjOTI2NjJlODllNThkMWIzYTc5OTZiYjNjODk4M2FlNGQzMjI1ZmJkZTMyMWUyY2MyYWY4ODhlMWNlMmQxMDlhNWJlZjZhM2ZkOCJ9',
		});
	};

	const showLoader = () => {
		if (document.querySelector('.paddle-checkout')) {
			document.querySelector('.paddle-checkout').classList.add('--loading');
		}
	};
	const hideLoader = () => {
		if (document.querySelector('.paddle-checkout')) {
			setTimeout(() => document.querySelector('.paddle-checkout').classList.remove('--loading'), 100);
		}
	};

	const handleFinalization = async e => {
		e.preventDefault();
		fblog('track', 'AddToCart', { value: Number(getPlan().price_usd), currency: 'USD' });
		eclog(getPlan(), 'add');
		log('Order', 'Store', 'InitiateCheckout');
		log('Order', 'Store', 'InitiateCheckout--stripe');
		slog(`Initiate Checkout (${getPlan().price_usd}, Stripe)`, values.json.email);
		eclog(getPlan(), 'checkout');
		const stripe = await loadStripe(
			process.env.NODE_ENV === 'production' &&
				!(typeof window !== 'undefined' && window.location.origin.indexOf('netlify') > -1)
				? order.stripe_live_key
				: order.stripe_test_key,
		);
		log('Order', 'Checkout', 'stripe_redirect');
		stripe
			.redirectToCheckout({
				items: [
					{
						plan:
							process.env.NODE_ENV === 'production' &&
							!(typeof window !== 'undefined' && window.location.origin.indexOf('netlify') > -1)
								? getPlan().stripe_live
								: getPlan().stripe_test,
						quantity: 1,
					},
				],
				successUrl: `${window.location.origin}/create-profile?id=${id}&sid={CHECKOUT_SESSION_ID}`,
				cancelUrl: `${window.location.origin}/choose-plan?cancel&id=${id}`,
				customerEmail: values.json.email,
			})
			.then(result => {
				alert(result.error.message);
				navigate('/choose-plan/');
			});
	};

	order.plans.map((item, index) => {
		if (item.value === true) {
			log('Order', 'Plan', item.name);
			fblog('trackCustom', 'plan_' + item.name);
			eclog(item, 'click');
		}
	});

	const renderSummary = () => {
		return (
			<>
				<div id="summary" />
				<Summary>
					<div className="headline">Order Summary</div>
					<div className="order">
						<div className="key">
							<strong>Reshape Weight Loss Plan</strong>
							{getPlan().title}
						</div>
						<div className="value">${getPlan().full_price_usd}</div>
						{Number(getPlan().discount_usd) > 0 && (
							<>
								<div className="key">
									Discount <span>({getPlan().discount})</span>
								</div>
								<div className="value">
									<span>-${getPlan().discount_usd}</span>
								</div>
							</>
						)}
					</div>
					<div className="total">
						<div className="key">TOTAL</div>
						<div className="value">${getPlan().price_usd}</div>
					</div>

					{GO('TogglePaddle', '7_kU-a-oSdWVEE17Zq6J2A', [
						<>
							<Bot>
								<label
									className={`${legal ? '--active' : '--inactive'} ${legalAlert ? '--alert' : ''}`}
								>
									<input type="checkbox" checked={legal} onChange={() => handleLegal('toggle')} />
									<div />
									<RichText data={order.default_bottom} />
								</label>
							</Bot>
							<PaymentBlock>
								<a href="/offer" onClick={e => handleFinalization(e)} className="checkOutButton">
									Checkout using Credit or Debit Card
								</a>
								<div className="checkOutBottom">
									<img src="/checkout.png" />
								</div>
								{typeof window !== 'undefined' && <PP />}
								{legal ? <></> : <div className="legalBlocker" onClick={() => handleLegal('alert')} />}
							</PaymentBlock>
						</>,
						<>
							<Bot style={{ textAlign: 'center' }}>
								<RichText data={order.alternative_bottom} />
							</Bot>
							<PaymentBlock>
								<Script
									url="https://cdn.paddle.com/paddle/paddle.js"
									onLoad={() => {
										window.Paddle.Setup({
											vendor: 116667,
											eventCallback: function(data) {
												log('Paddle', data.event, 'Overlay');
												if (data.event === 'Checkout.Loaded') {
													hideLoader();
													logPaddleLoaded('Overlay');
												}
											},
										});
									}}
								/>
								<div onClick={e => handlePaddleOverlay(e)} className="checkOutButton">
									Submit Secure Checkout
								</div>
								<div className="checkOutBottom">
									<img src="payment.svg" />
								</div>
							</PaymentBlock>
						</>,
						<>
							<Bot style={{ textAlign: 'center' }}>
								<RichText data={order.alternative_bottom} />
							</Bot>
							<PaymentBlock>
								<Script
									url="https://cdn.paddle.com/paddle/paddle.js"
									onLoad={() => {
										window.Paddle.Setup({
											vendor: 116667,
											eventCallback: function(data) {
												log('Paddle', data.event, 'Inline');
												if (data.event === 'Checkout.Loaded') {
													hideLoader();
												}
												if (data.event === 'Checkout.PaymentMethodSelected') {
													logPaddleLoaded('Inline');
												}
											},
										});
										showLoader();
									}}
								/>
								<div className="paddle-checkout">
									<div className="paddle-checkout-wrapper" />
									<div className="loader" />
								</div>
							</PaymentBlock>
						</>,
					])}
				</Summary>
			</>
		);
	};

	const logPaddleLoaded = type => {
		log('Order', 'Store', 'InitiateCheckout');
		log('Order', 'Store', 'InitiateCheckout--paddle');
		slog(
			`Initiate Checkout, (Paddle ${type})`,
			atob(new URLSearchParams(document.location.search).get('id') || ''),
		);
	};

	const handlePaypalClick = () => {
		clearTimeout(window.atcevent);
		window.atcevent = setTimeout(() => {
			fblog('track', 'AddToCart', { value: Number(getPlan().price_usd), currency: 'USD' });
			eclog(getPlan(), 'add');
			log('Order', 'Store', 'InitiateCheckout');
			log('Order', 'Store', 'InitiateCheckout--paypal');
			eclog(getPlan(), 'checkout');
			slog(`Initiate Checkout (${getPlan().price_usd}, Paypal)`, values.json.email);
		}, 500);
	};
	const PP = () => {
		return (
			<div>
				<PayPalButton
					onClick={() => handlePaypalClick()}
					amount={getPlan().price_usd}
					currency="USD"
					shippingPreference="NO_SHIPPING"
					style={{ label: 'checkout', height: 46 }}
					options={{
						vault: true,
						clientId:
							process.env.NODE_ENV === 'production' &&
							!(typeof window !== 'undefined' && window.location.origin.indexOf('netlify') > -1)
								? 'AU8gnUcaQNsxD_strs8Myx54XYYNmPQi6IkuPigztvgWJjvhpkJlmb1S_Hug91mNAsepTgqlqFERyMLD'
								: 'AV14at4GExgySgKTLjoPQ4hXoaBCeKqk2WV4udQFJbKadgJpbQXDfv6dCtxzNJne1kcxc6fiThn52olD',
						disableFunding: 'card',
					}}
					createSubscription={(data, actions) => {
						return actions.subscription.create({
							plan_id:
								process.env.NODE_ENV === 'production' &&
								!(typeof window !== 'undefined' && window.location.origin.indexOf('netlify') > -1)
									? getPlan().paypal_id
									: getPlan().paypal_sb_id,
						});
					}}
					onCancel={object => {
						return new Promise(function(resolve, reject) {
							setTimeout(() => {
								window.location.replace(`/choose-plan?cancel&id=${id}`);
							}, 300);
						});
					}}
					onApprove={(data, actions) => {
						return actions.subscription.get().then(function(details) {
							window.location.replace(
								process.env.NODE_ENV === 'production' &&
									!(typeof window !== 'undefined' && window.location.origin.indexOf('netlify') > -1)
									? `https://plan.reshape.me/create-profile?id=${id}&pid=${data.subscriptionID}`
									: window.location.origin + `/create-profile?id=${id}&pid=${data.subscriptionID}`,
							);
						});
					}}
				/>
			</div>
		);
	};
	return (
		<>
			<Meta />
			<Helmet>
				<script type="application/ld+json">
					{JSON.stringify({
						'@context': 'http://schema.org',
						'@type': 'WebPage',
						url: meta.domain,
						name: meta.title,
						description: meta.description,
					})}
				</script>
			</Helmet>
			<Layout>
				<Timer2 />
				<Benefits2
					onClick={() => {
						log('Payment', 'Engagement', 'click_benefits');
					}}
				>
					<Block>
						<h2>Lose weight and enjoy</h2>
						<div>
							{config.benefits.map((item, index) => (
								<div key={index}>
									<img src={item.image.url} />
									<p>{item.title}</p>
								</div>
							))}
						</div>
					</Block>
				</Benefits2>
				<PageWrapper>
					<RichText data={order.plan_body} />
					<Order2>
						<Plans2>
							{order.plans.map((item, index) => (
								<label className={item.value ? '--active' : '--inactive'} key={index}>
									<input
										type="radio"
										name="plan"
										value={item.name}
										defaultChecked={item.value}
										onChange={e => handleOptionChange(e)}
									></input>
									<div>
										<div className="status" />
										<div>
											<h2>{item.title}</h2>
											<h3>
												{item.price_number}
												<span>{item.price_subtitle}</span>
											</h3>
											<small>
												{item.subtitle.split(' ').map((item, index) => (
													<span key={index}>{item} </span>
												))}
											</small>
											<div className="discount">{item.discount}</div>
										</div>
									</div>
								</label>
							))}
						</Plans2>
						{renderSummary()}
					</Order2>
				</PageWrapper>
				<VisibilitySensor
					partialVisibility={true}
					onChange={v => v && log('Payment', 'Engagement', 'view_reviews')}
				>
					<Reviews
						onClick={() => {
							log('Payment', 'Engagement', 'click_reviews');
						}}
					>
						<Block>
							<h2>{config.reviews_title}</h2>
							<div>
								{config.reviews.map(
									(item, index) =>
										index < 2 && (
											<ReviewItem key={index}>
												<ReviewBody>
													<h3>{item.headline}</h3>
													<small>{item.text}</small>
												</ReviewBody>
												<ReviewFooter>
													<div>
														<img
															className="avatar"
															alt={item.person}
															src={item.image.url}
														/>
													</div>
													<div className="text">
														<strong>{item.person}</strong>
														<small>{item.subtitle}</small>
													</div>
													<img className="rating" src={item.rating.url} alt="rating" />
												</ReviewFooter>
											</ReviewItem>
										),
								)}
								<a className="cta" href={'#'} target="_blank" onClick={e => handleCallToAction(e)}>
									<Button type={1} hue={'pink'} title="Submit Secure Payment" />
								</a>
							</div>
						</Block>
					</Reviews>
				</VisibilitySensor>
			</Layout>
		</>
	);
};
